import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { LuTelescope } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';
import AnswerMarkdown from './AnswerMarkdown';
import QueryCitations from './QueryCitations';
import QueryDetailsButtons from './QueryDetailsButtons';
import ThinkingPhase from './ThinkingPhase';

const tabStyles = `
  .query-deep-research-tabs .ant-tabs-tab {
    font-size: 16px !important;
  }
`;

const { Text } = Typography;

const QueryDetailsDeepResearch = ({ query, onAnswerCopy, onShare, protectedPage }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('answer');

  if (query.isThinking()) {
    // Show only thinking phase for incomplete deep research queries
    return <ThinkingPhase content={query.getAnswerWithThinking()} isCompleted={false} />;
  }

  // Use tabs for completed deep research queries
  return (
    <>
      <style>{tabStyles}</style>
      <Tabs 
        activeKey={activeTab} 
        onChange={setActiveTab}
        className="query-deep-research-tabs"
        style={{ fontSize: '16px' }}
        items={[
        {
          key: 'answer',
          label: t('query_details_deep_research.answer_tab'),
          children: (
            <div style={{ fontSize: '16px' }}>
              <AnswerMarkdown isCompleted={query.isCompleted()} onCitationClick={() => {}}>
                {query.getAnswer()}
              </AnswerMarkdown>
              {query.getCitations() && query.isCompleted() &&
                <QueryCitations citations={query.getCitations()} />}
              {query.isCompleted() && protectedPage && (
                <QueryDetailsButtons
                  query={query}
                  onAnswerCopy={onAnswerCopy}
                  onShare={onShare}
                />
              )}
            </div>
          )
        },
        {
          key: 'thinking',
          label: t('query_details_deep_research.research_process_tab'),
          children: (
                          <div style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '16px', 
                borderRadius: '6px',
                border: '1px solid #e8e8e8'
              }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  marginBottom: '12px' 
                }}>
                  <LuTelescope 
                    size="1.2em" 
                    style={{ marginRight: '8px', color: '#1890ff' }} 
                  />
                  <Text strong style={{ color: '#1890ff' }}>
                    {t('query_details_deep_research.research_process_title')}
                  </Text>
                </div>
                <div style={{ 
                  fontSize: '15px',
                  lineHeight: '1.6',
                  color: '#666',
                  whiteSpace: 'pre-wrap',
                  fontFamily: 'monospace'
                }}>
                  {query.getThinkingContent() || t('query_details_deep_research.no_research_process')}
                </div>
              </div>
          )
        }
      ]}
      />
    </>
  );
};

export default QueryDetailsDeepResearch; 